export default __webpack_public_path__ + "media/images/react_icons/arrow-dates-right-ca634f7ef21da2f6845f13f9cd497f24.svg";